import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <p>ALL RIGHTS RESERVED © 2020</p>
    </div>
  );
};

export default Footer;
